import { buildUrl } from './utils';
import skills from './http-skills';

const state = {
  projects: {
    skills: {
      root: '/projects/:id/skills/'
    },
    root: '/projects/'
  }
};
const actions = {
  create({ rootState: { token } }, { name, description, color, collaborators = [] } = {}) {
    const url = buildUrl(state.projects.root);
    return this._vm.$http
      .post(
        url,
        {
          name,
          description,
          color,
          collaborators
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then(({ data }) => Promise.resolve(data));
  },
  get({ rootState: { token } }, { sort, showAll = false } = {}) {
    const url = buildUrl(state.projects.root);
    const params = {
      sort
    };
    if (showAll) {
      params.showAll = true;
    }
    return this._vm.$http
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params
      })
      .then(({ data }) => Promise.resolve(data));
  },
  remove({ rootState: { token } }, projectId) {
    const url = buildUrl([
      {
        [state.projects.root]: projectId
      }
    ]);
    return this._vm.$http
      .delete(url, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(({ data }) => Promise.resolve(data));
  },

  getFavorites({ rootState: { token } }) {
    const url = buildUrl('/users/me/favorite-projects');
    return this._vm.$http
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(({ data }) => Promise.resolve(data));
  },

  addToFavorite({ rootState: { token } }, { projectId }) {
    const url = buildUrl('/users/me/favorite-projects');
    return this._vm.$http
      .post(
        url,
        { projectId },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then(({ data }) => Promise.resolve(data));
  },
  removeFromFavorite({ rootState: { token } }, { projectId }) {
    const url = buildUrl([{ '/users/me/favorite-projects': projectId }]);
    return this._vm.$http
      .delete(url, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(({ data }) => Promise.resolve(data));
  }
};
export default {
  namespaced: true,
  state,
  actions,
  modules: {
    skills
  }
};
